// extracted by mini-css-extract-plugin
module.exports = {"segmentHeader":"PickedBinsGroupsReport_segmentHeader__8G65k","customTooltip":"PickedBinsGroupsReport_customTooltip__1Pxsv","loader":"PickedBinsGroupsReport_loader__34EYm"};